<template>
  <div id="Bgreviewtwo">
    <Head />
    <div class="hotspot clear">
      <Nav ms="/Bgreviewtwo" />
      <div v-if="tabClick == 0" class="H-right">
        <div class="title1">成果审核管理</div>
        <div class="H-header">
          <div class="t-left">
            <div class="select">
              <!-- <select v-model="year" @change="setYear">
                <option value="2022">2022</option>
                <option value="2021">2021</option>
                <option value="2020">2020</option>
              </select> -->
              <el-date-picker
                v-model="year"
                type="year"
                @change="setYear"
                :default-value="value"
                value-format="yyyy"
                :picker-options="pickerOptions"
                placeholder="请选择"
                :clearable="false"
              >
              </el-date-picker>
              <select v-model="lx" @change="getCg">
                <option value="0">待审核</option>
                <option value="1">待分配</option>
                <option value="2">待评审</option>
                <option value="3">已评审</option>
                <option value="4">已暂存</option>
                <option value="5">子级公司审核节点</option>
              </select>
              <el-select
                v-if="lx == 5"
                placeholder="请输入公司名称"
                @change="search()"
                filterable
                clearable
                v-model="SuperiorD"
                class="search-input"
              >
                <el-option
                  v-for="(item, i) in companyList"
                  :key="i"
                  :value="item.ID"
                  :label="item.Name"
                >
                </el-option>
              </el-select>
              <el-input
                placeholder="请输入成果名称或评审编号"
                v-model="keyword"
                class="search-input"
              ></el-input>
              <select
                v-if="lx == 1"
                @change="getMajor1Value($event)"
                v-model="major1Value"
              >
                <option value>请选择专业大方向</option>
                <option v-for="(item, i) in major1" :key="i" :value="item.ID">
                  {{ item.Classname }}
                </option>
              </select>
              <!-- <select
                @change="getMajor2Value($event)"
                :disabled="major2.length>0?false:true"
                v-model="major2Value"
              >-->
              <select
                v-if="lx == 1"
                :disabled="major2.length > 0 ? false : true"
                @change="getClassify($event)"
                v-model="major2Value"
              >
                <option value>请选择专业小方向</option>
                <option v-for="(item, i) in major2" :key="i" :value="item.ID">
                  {{ item.Classname }}
                </option>
              </select>
            </div>
            <div class="btn1" @click="excel()" v-show="lx == 0">
              <i></i>
              导出数据
            </div>
            <div
              class="btn btnmini"
              style="width: 1rem; margin: 0"
              v-show="lx == 0"
              @click="openEl"
            >
              批量审核
            </div>
            <div
              class="btn btnmini"
              style="width: 1rem; margin: 0"
              v-if="lx == 1"
              @click="Popups(1, batchArr[0])"
            >
              批量分配
            </div>
          </div>
        </div>
        <div class="t_main">
          <el-table
            border
            :header-cell-style="{
              'background-color': '#001743',
              color: '#fff',
              height: '0.5rem',
            }"
            :stripe="true"
            :data="tableData1"
            style="width: 100%; max-height: 95%"
            :row-style="{ height: '0.4rem' }"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              type="selection"
              width="40"
              :key="Math.random()"
              v-if="lx == 1 || lx == 0"
            ></el-table-column>
            <!-- <el-table-column :key="Math.random()" width="50" type="index" label="编号" header-align="center"
                            align="center">
                        </el-table-column>-->
            <!-- <el-table-column
              label="序号"
              align="center"
              width="60"
              prop="index"
            ></el-table-column> -->
            <el-table-column
              v-if="lx != 5"
              label="评审编号"
              align="center"
              width="110"
              sortable
              prop="accessNo"
            ></el-table-column>
            <el-table-column
              label="成果编号"
              align="center"
              width="80"
              prop="ID"
            ></el-table-column>
            <el-table-column
              :key="Math.random()"
              min-width="200px"
              prop="Title"
              label="成果名称"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              :key="Math.random()"
              width="150px"
              prop="Classname"
              label="分类"
              header-align="center"
              align="center"
            >
              <template slot-scope="s">
                <ul>
                  <li>{{ s.row.ParentClassName }}</li>
                  <li>{{ s.row.Classname }}</li>
                </ul>
              </template>
            </el-table-column>
            <el-table-column
              :key="Math.random()"
              width="150px"
              prop="companyname"
              label="所属单位"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              :key="Math.random()"
              v-if="lx == 5"
              width="100px"
              prop="checkname"
              label="当前审核节点"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              :key="Math.random()"
              width="100px"
              prop="DeclarTime"
              label="申报时间"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              :key="Math.random()"
              v-if="lx == 0"
              width="100px"
              prop="Phone"
              label="手机号"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              v-if="lx == 0"
              :key="Math.random()"
              width="100px"
              prop="tyzb"
              label="财务指标状态"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              :key="Math.random()"
              v-if="lx == 0"
              width="100px"
              prop="zyzb"
              label="专业指标状态"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              :key="Math.random()"
              width="100px"
              label="评审组"
              header-align="center"
              align="center"
              v-if="S == 4"
            >
              <template slot-scope="scope">
                <p v-if="scope.row.ExpertGroup">
                  {{ scope.row.ExpertGroup.GroupName }}
                </p>
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              fixed="right"
              :key="Math.random()"
              header-align="center"
              align="center"
              :width="wid"
            >
              <template slot-scope="scope">
                <div class="btns">
                  <el-button
                    size="small"
                    v-if="scope.row.Status == 1 && !scope.row.node_msg"
                    style="background: #2d65d2; color: #ffffff"
                    @click="bgreviewView(scope.row)"
                    >审核</el-button
                  >
                  <el-button
                    size="mini"
                    v-if="scope.row.Status == 1 && !scope.row.node_msg"
                    type="primary"
                    @click="childchange(scope.row)"
                    >查看</el-button
                  >
                  <el-button
                    size="mini"
                    v-if="scope.row.Status == 1 && !scope.row.node_msg"
                    type="danger"
                    @click="downloadAll(scope.row)"
                    >下载</el-button
                  >
                  <el-button
                    size="mini"
                    v-if="scope.row.Status == 2 && !scope.row.node_msg"
                    style="background: #2d65d2; color: #ffffff"
                    @click="Popups('1', scope.row)"
                    >分配</el-button
                  >
                  <el-button
                    size="mini"
                    v-if="scope.row.Status == 2 && !scope.row.node_msg"
                    style="background: #2d65d2; color: #ffffff"
                    @click="bgreviewView(scope.row)"
                    >查看</el-button
                  >
                  <el-button
                    size="mini"
                    v-if="scope.row.Status == 4 && !scope.row.node_msg"
                    style="background: #2d65d2; color: #ffffff"
                    @click="bgreviewView(scope.row)"
                    >查看</el-button
                  >
                  <el-button
                    size="mini"
                    v-if="scope.row.Status == 5 && !scope.row.node_msg"
                    style="
                      background: #2d65d2;
                      color: #ffffff;
                      padding: 7px 10px;
                    "
                    @click="bgreviewView(scope.row)"
                    >查看</el-button
                  >
                  <el-button
                    size="mini"
                    v-if="scope.row.Status == 5 && !scope.row.node_msg"
                    style="
                      background: #2d65d2;
                      color: #ffffff;
                      padding: 7px 10px;
                    "
                    @click="Zhuanjias('1', scope.row)"
                    >评审结果</el-button
                  >
                  <el-button
                    size="mini"
                    v-if="scope.row.Status == 7 && !scope.row.node_msg"
                    style="background: #2d65d2; color: #ffffff"
                    @click="bgreviewView(scope.row)"
                    >查看</el-button
                  >
                  <el-button
                    size="mini"
                    v-if="scope.row.node_msg == 'checking'"
                    style="background: #2d65d2; color: #ffffff"
                    @click="bgreviewView(scope.row)"
                    >查看</el-button
                  >
                </div>
                <el-dropdown>
                  <el-button
                    type="primary"
                    style="padding: 0 5px; height: 30px"
                  >
                    选择操作
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item>
                      <template>
                        <span
                          v-if="scope.row.Status == 1 && !scope.row.node_msg"
                          @click="bgreviewView(scope.row)"
                          >审核</span
                        >
                      </template>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <template>
                        <span
                          v-if="scope.row.Status == 1 && !scope.row.node_msg"
                          @click="childchange(scope.row)"
                          >查看</span
                        >
                      </template>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <template>
                        <span
                          v-if="scope.row.Status == 1 && !scope.row.node_msg"
                          @click="downloadAll(scope.row)"
                          >一键下载</span
                        >
                      </template>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <template>
                        <span
                          v-if="scope.row.Status == 2 && !scope.row.node_msg"
                          @click="Popups('1', scope.row)"
                          >分配</span
                        >
                      </template>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <template>
                        <span
                          v-if="scope.row.Status == 2 && !scope.row.node_msg"
                          @click="bgreviewView(scope.row)"
                          >查看</span
                        >
                      </template>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <template>
                        <span
                          v-if="scope.row.Status == 4 && !scope.row.node_msg"
                          @click="bgreviewView(scope.row)"
                          >查看</span
                        >
                      </template>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <template>
                        <span
                          v-if="scope.row.Status == 5 && !scope.row.node_msg"
                          @click="bgreviewView(scope.row)"
                          >查看</span
                        >
                      </template>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <template>
                        <span
                          v-if="scope.row.Status == 5 && !scope.row.node_msg"
                          @click="Zhuanjias('1', scope.row)"
                          >评审结果</span
                        >
                      </template>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <template>
                        <span
                          v-if="scope.row.Status == 7 && !scope.row.node_msg"
                          @click="bgreviewView(scope.row)"
                          >查看</span
                        >
                      </template>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <template>
                        <span
                          v-if="scope.row.node_msg == 'checking'"
                          @click="bgreviewView(scope.row)"
                          >查看</span
                        >
                      </template>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            style="text-align: right; height: 0.45rem"
            v-if="tableData1.length > 0"
            @current-change="CurrentChange1"
            @size-change="handleSizeChange1"
            :current-page="Page1"
            :page-size="PageSize1"
            :page-sizes="[10, 20, 30]"
            layout="total,sizes, prev, pager, next, jumper"
            :total="total1"
          ></el-pagination>
          <el-dialog
            title="分配专家"
            :visible.sync="isPopup"
            width="600px"
            :before-close="handleClose"
          >
            <!-- <div class="Popup" v-show="isPopup"> -->
            <div class="none" @click="Popups(0)"></div>
            <div v-show="isPopup" class="a_forms">
              <!-- <div class="f-top">
                <i
                  class="el-dialog__close el-icon el-icon-close"
                  @click="Popups(0)"
                ></i
                >分配专家
              </div> -->
              <div class="f-info">
                <div class="p-info">
                  <!-- <div class="p-input" v-if="batchArr.length==0">
                    <span>项目名称：</span>
                    <input disabled="disabled" type="text" v-if="infoForm" v-model="infoForm.Title" />
                    <i></i>
                  </div>-->
                  <div>
                    <span>项目分组：</span>
                    <el-select v-model="addExpertReport">
                      <!-- <el-option value>请选择组</el-option> -->
                      <el-option
                        v-for="(item, index) in Groups"
                        :value="item.GroupID"
                        :key="index"
                        :label="item.GroupName"
                      >
                      </el-option>
                      <!-- <option value="1">组1</option>
                      <option value="2">组2</option>
                      <option value="3">组3</option>-->
                    </el-select>
                  </div>
                </div>

                <!-- <div class="f-bottom">
                  <el-button @click="isPopup = false">取 消</el-button>
                  <el-button type="primary" @click="exportSubmit()"
                    >确 定</el-button
                  >
                </div> -->
              </div>
            </div>
            <span slot="footer" class="dialog-footer">
              <el-button @click="isPopup = false">取 消</el-button>
              <el-button type="primary" @click="exportSubmit()"
                >确 定</el-button
              >
            </span>
            <!-- </div> -->
          </el-dialog>
          <!-- <div class="Popup" v-show="isZhuanjia">
            <div class="none" @click="Zhuanjias(0)"></div>
            <div v-if="isZhuanjia" class="a_forms">
              <el-table
                border
                :header-cell-style="{'background-color': '#001743','color': '#fff','height':'0.5rem'}"
                :stripe="true"
                :data="tableData1"
                style="width: 100%;max-height:95%"
                :row-style="{'height':'0.4rem'}"
              ></el-table>
            </div>
          </div>-->
        </div>
        <!-- <div class="l-main" v-else>
          <div class="list" v-for="(item,index) in tableData1" :key="index">
            <div class="content">
              <div class="content-name">
                <span>成果名称：</span>
                <span>{{item.Title}}</span>
              </div>
              <div class="content-time">
                <span>申报时间：</span>
                <span>{{item.DeclarTime}}</span>
              </div>
              <div class="content-group">
                <span>组1：</span>
                <span></span>
              </div>
            </div>
            <div class="content">
              <p>待评审</p>
            </div>
            <div class="btn btnmini">评审</div>
          </div>
        </div>-->
      </div>
      <!-- newwwww -->
      <el-dialog
        title="成果审核管理"
        :visible.sync="bgreviewVisible"
        width="1200px"
        :before-close="handleClose"
      >
        <BgreviewDialog
          :baogao="baogao"
          :percentage="percentage"
          :user="user"
          :status="S"
          :yulan="yulan"
          :sbbYear="sbbYear"
          :sbb="sbb"
          :zgzbg1="zgzbg1"
          :fj="fj"
          :baogaoUrl="baogaoUrl"
          @close="close"
        ></BgreviewDialog>
        <span slot="footer" class="dialog-footer">
          <el-button @click="bgreviewVisible = false">取 消</el-button>
        </span>
      </el-dialog>

      <div v-if="tabClick == 1" class="H-right">
        <div class="title1">成果审核管理</div>
        <!-- <div class="btn btnmini" style="margin-bottom: 0.2rem" @click="tabchange(0)">
                    返回
                </div> -->
        <!-- <div class="info">
          <div class="clear">
            <span></span>
            <div style="font-weight:bold;">{{user.Title}}</div>
          </div>
          <div class="clear">
            <span></span>
            <div class="upload" @click="tabchange(2,0,1)">成果申请表</div>
          </div>
          <div class="clear">
            <span></span>
            <div class="upload" @click="tabchange(2,0,2)">成果主报告</div>
          </div>
          <div class="clear">
            <span></span>
            <div class="upload" @click="tabchange(2,0,3)">成果附件</div>
          </div>
        </div>-->
        <div class="info">
          <div>
            成果名称：
            <b>{{ user.Title }}</b>
          </div>
          <div>
            申报单位：
            <b>{{ user.companyname }}</b>
          </div>
          <div class="left-button">
            <p>成果报告申请表:</p>
            <!-- <span class="span1" @click="tabchange(2,0,1)">预览</span> -->
            <div class="lastBtn">
              <el-button
                type="primary"
                style="width: 1rem"
                @click="tabchange(2, 0, 1)"
                >预览</el-button
              >
              <el-button
                style="width: 1rem; background: rgb(243, 37, 47); color: #fff"
                @click="dowCg(1)"
                >下载</el-button
              >
            </div>
          </div>
          <div class="left-button">
            <p>成果主报告:</p>
            <!-- <span class="span2" @click="tabchange(2,0,2)">预览</span> -->
            <div class="sendBtn">
              <el-button
                type="primary"
                style="width: 1rem"
                @click="tabchange(2, 0, 2)"
                >预览</el-button
              >
              <el-button
                style="width: 1rem; background: rgb(243, 37, 47); color: #fff"
                @click="dowCg(2)"
                >下载</el-button
              >
            </div>
          </div>
          <div>
            <p>成果附件:</p>
            <div>
              <el-button
                style="
                  width: 1rem;
                  background: rgb(243, 37, 47);
                  color: #fff;
                  margin-left: 1.15rem;
                "
                @click="tabchange(2, 0, 3)"
                >下载</el-button
              >
            </div>
            <!-- <span>无</span> -->
          </div>
          <div>
            <p>成果进度:</p>
            <div>
              <el-button
                style="width: 1rem; margin-left: 1.15rem"
                type="success"
                @click="getJd(user.ID)"
                >进度</el-button
              >
            </div>
            <!-- <span>无</span> -->
          </div>
          <!-- <div>上传时间：<span>2019-02-25</span></div>
          <div><span>成果摘要：</span><div>由于现代网络技术的不断发展，我国长期的能源产业——煤炭经济运营模式也开始发生变化。我国的煤炭企业面临着，经济运营模式转型的巨大挑战，要想实现可持续发展，就必须将煤炭企业的运营方案与现代网络技术相互结合。在信息化背景下，煤炭企业要在企业内部信息化建设上进行调整，做到与时俱进，不断创新。煤炭工程成本管理提高企业经济效益</div></div>-->
          <!-- <div class="clear">
            <span></span>
            <div style="font-weight:bold;">{{user.Title}}</div>
          </div>
          <div class="clear">
            <span></span>
            <div class="upload" @click="tabchange(2,0,1)">
              成果申请表
            </div>
          </div>
          <div class="clear">
            <span></span>
            <div class="upload" @click="tabchange(2,0,2)">
              成果主报告
            </div>
          </div>
           <div class="clear">
            <span></span>
            <div class="upload" @click="tabchange(2,0,3)">
              成果附件
            </div>
          </div>-->
        </div>
        <div class="jieguo">
          <i></i>
          <span class="jieguospan">查重结果:</span>
          <span v-if="baogao.wordRepetitionRate" class="repetition"
            >{{ percentage }}相似</span
          >
          <!-- <a :href="baogaoUrl||'javascript:;'" target="_blank" style="color:#2D65D2;">点击查看</a> -->
          <a @click="tabchange(2, 0, 4)" style="color: #2d65d2">点击查看</a>
        </div>
        <div class="yijian">
          <div>
            <div></div>
            <span>审核意见：</span>
          </div>
          <div v-if="S != 1 && ideas" class="opinion">{{ ideas }}</div>
          <textarea
            name
            id
            cols="30"
            rows="10"
            v-model="comment"
            v-if="S == 1"
          ></textarea>
        </div>
        <div class="sub" v-if="S == 1">
          <div class="btn" @click="submit(2)">通过</div>
          <div
            class="btn"
            style="margin-left: 0.5rem; background: #d93838"
            @click="submit(3)"
          >
            不通过
          </div>
          <div
            class="btn"
            style="margin-left: 0.5rem; background: #f76423"
            @click="submit(7)"
          >
            暂存
          </div>
        </div>
        <div
          class="btn btnmini"
          style="margin-bottom: 0.2rem"
          @click="tabchange(0)"
        >
          返回
        </div>
      </div>
      <div v-if="tabClick == 2" class="H-right">
        <div
          class="btn btnmini"
          style="margin-bottom: 0.2rem; position: fixed"
          @click="tabchange(1)"
        >
          返回
        </div>
        <Preview
          v-if="lookStatus == 1"
          :yulan="yulan"
          :sbbYear="sbbYear"
          :CompanyID="user.CompanyID"
        />
        <!-- <iframe id='bbb' v-show="lookStatus==2" width=1000  name=hrong height=1000 frameborder="0"></iframe>
          
        <iframe id='aaa' v-show="lookStatus==3" width=1000 name=hrong height=1000 frameborder="0"></iframe>-->
        <FullPreview v-if="lookStatus == 2" :zbg="user.ID" />
        <iframe
          v-if="lookStatus == 4"
          width="1000"
          style="width: 100%"
          height="1000"
          frameborder="0"
          :src="baogaoUrl"
        ></iframe>
      </div>
    </div>
    <el-dialog
      :title="title"
      :visible.sync="childVisible"
      width="12.5rem"
      :before-close="handleClose"
    >
      <SpecificationDialog
        ref="child"
        @child-quit="tabchange(0)"
        :CompanyID="user.CompanyID"
      >
      </SpecificationDialog>
    </el-dialog>

    <!-- <el-dialog title="分配专家组" :visible.sync="isPopup" top="20vh" width="30%">
      <el-form>
        <el-form-item label="组名">
          <select v-model="addExpertReport" style="width:80%;height:.4rem">
            <option value>请选择组</option>
            <option
              v-for="(item,index) in Groups "
              :value="item.GroupID"
              :key="index"
            >{{item.GroupName}}</option>
          </select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isPopup = false">取 消</el-button>
        <el-button type="primary" @click="exportSubmit()">确 定</el-button>
      </div>
    </el-dialog>-->
    <!-- 评审结果 -->
    <el-dialog
      v-if="isZhuanjia"
      title="评审结果"
      :visible.sync="dialogVisible1"
      :destroy-on-close="true"
      center
      top="20vh"
      width="70%"
      style="font-size: 0.2rem"
    >
      <div class="block">
        <el-timeline>
          <el-timeline-item
            :timestamp="item.FinTime"
            placement="top"
            v-for="(item, i) in tableData2"
            :key="i"
          >
            <el-card>
              <div class="head">
                <img src="../../assets/back/avatar.png" alt />
                <h4>{{ item.Realname }}</h4>
                <div>
                  <span>{{ item.ParentClassName }}</span>
                  <span>{{ item.ClassName }}</span>
                </div>
                <div>
                  <span>{{ item.Phone }}</span>
                </div>
              </div>
              <div class="content" v-if="item.FinTime">
                <div class="total">
                  总分：
                  <span style="color: red">{{ item.total }}</span>
                </div>
                <div class="score">
                  <span>创新性：{{ item.score1 }}</span>
                  <span>科学性：{{ item.score2 }}</span>
                  <span>实践性：{{ item.score3 }}</span>
                  <span>效益性：{{ item.score4 }}</span>
                  <span>示范性：{{ item.score5 }}</span>
                  <span>规范性-材料格式：{{ item.score6 }}</span>
                  <span>规范性-文字描述：{{ item.score7 }}</span>
                </div>
                <div class="yj">
                  <span>评审意见：</span>
                  <div>{{ item.comment }}</div>
                </div>
              </div>
              <div class="uncontent" v-else>暂未评审</div>
            </el-card>
          </el-timeline-item>
          <!-- <el-timeline-item timestamp placement="top">
            <el-card>
              <div class="head">
                <img src="../../assets/back/avatar.png" alt />
                <h4>专家姓名</h4>
                <div>
                  <span>战略管理与商业模式</span>
                  <span>商业模式</span>
                </div>
                <div>
                  <span>1781345678</span>
                </div>
              </div>
              <div class="total">
                总分：
                <span style="color:red">70</span>
              </div>
              <div class="score">
                <span>创新性：10</span>
                <span>科学性：10</span>
                <span>实践性：5</span>
                <span>效益性：10</span>
                <span>示范性：10</span>
                <span>规范性-材料格式：10</span>
                <span>规范性-文字描述：10</span>
              </div>
              <div class="yj">
                <span>评审意见：</span>
                <div>王小虎 提交于 2018/4/3 20:46王小虎 提交于王小虎 提交于王小虎 提交于王小虎 提交于王小虎 提交于王小虎 提交于王小虎 提交于</div>
              </div>
            </el-card>
          </el-timeline-item>-->
        </el-timeline>
      </div>
    </el-dialog>
    <el-dialog
      title="提示"
      class="myEl"
      :visible.sync="dialogVisible2"
      width="30%"
      :before-close="handleClose"
    >
      <span>是否将选中的论文批量操作,</span>
      <span style="color: red">操作后不可修改!</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submits(2)">通 过</el-button>
        <el-button type="danger" @click="submits(3)">不通过</el-button>
        <el-button type="danger" style="background: #f76423" @click="submits(7)"
          >暂存</el-button
        >
      </span>
    </el-dialog>

    <Foot />
  </div>
</template>
<script>
import Head from "../../components/BackHead";
import Foot from "../../components/Foot";
import Nav from "../../components/BackNav";
import Preview from "@/views/Declare/Preview";
import FullPreview from "../Declare/FullPreview";
import SpecificationDialog from "./SpecificationDialog";
import BgreviewDialog from "./BgreviewDialog";
export default {
  name: "Expert",
  data() {
    return {
      value1: "1",
      tabClick: 0,
      total: 1,
      date: "",
      lookStatus: "",
      addExpertReport: "",
      lssss: [],
      comment: "", // 意见
      yulan: "",
      sbbYear: "", //申报表年份
      lx: "0",
      tableData1: [],
      tableData2: [],
      contentInfo: "",
      options: [],
      cgzbg: "",
      Page1: 1,
      svalue: 2,
      PageSize1: 30,
      isPopup: false,
      isZhuanjia: false,
      Idvalue: "",
      reportstatus: "",
      fpstatus: "",
      infoForm: {
        Title: "",
        Details: "",
        Date: "",
        Type: "1",
        Status: 0,
        FileCode: "",
      },
      baogaoUrl: "",
      baogao: "",
      oldForm: {
        Title: "",
        Details: "",
        Date: "",
        Type: "1",
        Status: 0,
        FileCode: "",
      },
      zbgdata: [], //主报告数据
      showall: "",
      fj: "",
      sbb: "",
      cgzbg1: "",
      ReportIDS: "", //批量操作
      major1: [],
      major2: [],
      major1Value: "", //一级专业
      major2Value: "", //二级专业
      batchArr: [],
      user: {},
      percentage: "", //重复率

      dialogVisible: false,
      active: "",
      S: "",
      ideas: "", //审核意见
      dialogVisible1: false,
      Groups: [],
      dialogFormVisible: false,
      lists: [],
      dialogVisible2: false,
      keyword: "",
      show: false,
      show1: false,
      showTable: false,
      year: new Date().getFullYear().toString(), //element组件默认值为String，传数字会读取不出来
      pickerOptions: {
        // 禁选今日之后的时间,time是当前时间选择器的显示内容
        disabledDate(time) {
          const date = new Date(); //获取当前时间信息
          const year = date.getFullYear(); //获取当前年份
          const timeYear = time.getFullYear(); //获取时间选择器的所有年份
          // 2020之前与今年之后的全部禁用
          return timeYear < 2020 ? timeYear < 2020 : timeYear > year;
        },
      },
      companyList: [],
      SuperiorD: "",
      // wid: "",
      //审核弹窗
      bgreviewVisible: false,
      childVisible: false,
    };
  },
  mounted() {
    // if (window.outerWidth < 1800) this.wid = "100";
    // else this.wid = "210";
    console.log(window.innerWidth);
  },
  computed: {
    wid() {
      return window.innerWidth < 1800 ? "100px" : "210px";
    },
  },

  created() {
    this.getlx();
    this.getMajor1();
    this.getComanyAll();
    //this.getdoctor();
  },
  methods: {
    getComanyAll() {
      this.$axios
        .post(
          "company/alllist",
          this.$qs.stringify({
            token: sessionStorage.getItem("token"),
          })
        )
        .then((res) => {
          this.companyList = res.data.data.list;
        });
    },
    excel() {
      var token = sessionStorage.getItem("token");
      window.location.href = `${this.$URL}/excel/reports?token=${token}&year=${this.year}`;
    },
    submits(i) {
      let that = this;
      var json = [];
      this.lists.map((val) => {
        json.push({
          ID: val.ID,
          Status: i,
          comment: "",
        });
      });
      that.$axios
        .post(
          "report/Batch_updatestatus",
          that.$qs.stringify({
            token: sessionStorage.getItem("token"),
            IDS: JSON.stringify(json),
          })
        )
        .then((res) => {
          if (res.data.code == 10000) {
            that.$message({
              type: "success",
              message: res.data.msg,
            }),
              that.getlx();
            that.lists = [];
            that.dialogVisible2 = false;
          } else {
            that.$message({
              type: "warning",
              message: res.data.msg,
            }),
              that.getlx();

            that.dialogVisible2 = false;
          }
        });
    },
    openEl() {
      if (this.lists.length > 0) {
        this.dialogVisible2 = true;
      } else {
        this.$message({
          type: "warning",
          message: "请选择需要操作的报告！",
        });
      }
    },
    getJd(id) {
      let that = this;
      for (let key in that.end) {
        that.end[key] = "";
      }
      this.$axios
        .post(
          "flow/flowtimeline",
          this.$qs.stringify({
            ReportID: id,
            token: sessionStorage.getItem("token"),
          })
        )
        .then((res) => {
          that.jindu = [];
          if (res.data.code == 10000) {
            that.jindu = res.data.data;
            if (this.jindu.length > 0) {
              this.dialogVisible = true;
              that.useRsubmit.time = this.jindu[0].datetime;
              that.useRsubmit.zt = "已提交";
              that.jindu.forEach(function(val, index) {
                // if(val.operation==)
                switch (val.operation) {
                  case "1":
                    val.zt = "待审核";
                    break;
                  case "2":
                    val.zt = "审核通过";
                    break;
                  case "3":
                    val.zt = "审核未通过";
                    break;
                  case "4":
                    val.zt = "待评分";
                    break;
                }
                that.jindu[0].companyName = "";
                that.jindu[0].zt = "已提交";
                if (
                  val.companyName == val.nextcompanyName &&
                  val.operation == 1
                ) {
                  val.zt = "提交成果";
                  val.companyName = "";
                }
                if (
                  index == that.jindu.length - 1 &&
                  val.sysmsg == "审核通过！" &&
                  val.operator != 1
                ) {
                  that.end.time = that.jindu[index].datetime;
                  that.end.zt = "待审核";
                  that.end.nextcompanyName = val.nextcompanyName;
                }
                if (
                  index == that.jindu.length - 1 &&
                  val.sysmsg == "审核通过！" &&
                  val.operator == 1
                ) {
                  that.end.time = that.jindu[index].datetime;
                  that.end.zt = "待评分";
                  that.end.nextcompanyName = val.nextcompanyName;
                }
                if (index == that.jindu.length - 1 && val.companyName == "") {
                  that.end.time = that.jindu[index].datetime;
                  that.end.zt = "待审核";
                  that.end.nextcompanyName = val.nextcompanyName;
                }
                if (
                  index == that.jindu.length - 1 &&
                  val.operation == 3 &&
                  val.companyID != val.nextcompanyID
                ) {
                  that.end.time = that.jindu[index].datetime;
                  that.end.zt = "待审核";
                  that.end.nextcompanyName = val.nextcompanyName;
                }
                if (
                  index == that.jindu.length - 1 &&
                  val.sysmsg === null &&
                  val.operation != 1
                ) {
                  // that.end.time = that.jindu[index].datetime;
                  // that.end.zt = "待评分";
                  // that.end.nextcompanyName ="";
                  for (let key in that.end) {
                    that.end[key] = "";
                  }
                }

                if (
                  val.sysmsg == "审核通过！" &&
                  val.companyName == "中国煤炭工业协会"
                ) {
                  that.jindu = that.jindu.slice(0, index + 1);
                }
                if (that.jindu.length == 0) {
                  that.active = 1;
                } else {
                  that.active = that.jindu.length;
                }
              });
            } else {
              this.$message({
                type: "warning",
                message: "暂无进度信息",
              });
            }
          } else if (res.data.code == 10002) {
            this.$message({
              type: "warning",
              message: res.data.msg,
            });
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    getMajor1() {
      this.$axios.post("classification/index?SuperiorD=0").then((res) => {
        this.major1 = res.data.data.list;
      });
    },
    getMajor1Value: function() {
      this.major2 = [];
      this.$axios
        .post("classification/index?SuperiorD=" + this.major1Value)
        .then((res) => {
          this.major2 = res.data.data.list;
        });
    },
    getClassify: function() {
      this.getlx();
    },

    handleSelectionChange(val) {
      if (this.lx == 0) {
        this.lists = val;
      } else {
        this.ReportIDS = "";
        this.batchArr = val;
        val.forEach((a) => {
          this.ReportIDS += a.ID + ",";
        });
        this.ReportIDS = this.ReportIDS.slice(0, this.ReportIDS.length - 1);
      }
    },

    setYear() {
      this.Page1 = 1;
      this.PageSize1 = 30;
      this.getlx();
    },
    getCg() {
      this.major1Value = "";
      this.major2Value = "";
      this.keyword = "";
      this.Page1 = 1;
      this.PageSize1 = 30;
      this.getlx();
    },

    downloadAll(item) {
      var that = this;
      that.$axios
        .post(
          "excel/zip?token=" + sessionStorage.getItem("token"),
          that.$qs.stringify({
            ID: item.ID,
          })
        )
        .then((res) => {
          if (res.data.code == 10000) {
            window.location.href = res.data.filepath;
          } else {
            this.$message({
              message: res.data.msg,
              type: "warning",
            });
          }
        });
    },
    getBaogao() {
      var that = this;
      that.$axios
        .post(
          "check/ccresult?token=" + sessionStorage.getItem("token"),
          that.$qs.stringify({
            ReportID: this.user.ID,
          })
        )
        .then((res) => {
          if (res.data.code == 10000) {
            if (res.data.data[0]) {
              if (!res.data.data[0].ResultLink) {
                this.baogaoUrl = res.data.data[0].Result;
              } else {
                this.baogaoUrl = res.data.data[0].ResultLink;
              }

              this.baogao = res.data.data[0];
              this.percentage = (
                res.data.data[0].wordRepetitionRate * 100
              ).toFixed(2);
            }
          } else {
            this.$message({
              message: res.data.msg,
              type: "warning",
            });
          }
        });
    },
    submit(e, arr) {
      var that = this;
      if (this.lx == 0) {
        this.fpstatus = this.user["ID"];
      } else {
        this.fpstatus = this.infoForm["ID"];
      }
      this.$confirm("确认操作, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          that.$axios
            .post(
              "report/updatestatus?token=" + sessionStorage.getItem("token"),
              that.$qs.stringify({
                ID: arr || this.fpstatus,
                Status: e,
                comment: this.comment,
              })
            )
            .then((res) => {
              if (res.data.code == 10000) {
                that.tabchange(0);
                // if (arr) {

                //   that.getlx();
                // }
                that.comment == "";
                that.$message({
                  message: res.data.msg,
                  type: "success",
                });
                that.getlx();
                that.isPopup = false;
              } else {
                that.$message({
                  message: res.data.msg,
                  type: "warning",
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },

    exportSubmit() {
      var that = this;
      this.$confirm("确认分配吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          that.$axios
            .post(
              "review/addExpertReport?token=" + sessionStorage.getItem("token"),
              that.$qs.stringify({
                ReportIDS: that.ReportIDS || this.infoForm.ID,
                GroupID: this.addExpertReport,
              })
            )
            .then((res) => {
              if (res.data.code == 10000) {
                that.$message({
                  message: res.data.msg,
                  type: "success",
                });
                if (that.batchArr.length > 0) {
                  that.batchArr.forEach((val) => {
                    that.setStatus(val.ID);
                  });

                  that.batchArr = [];
                  that.isPopup = !that.isPopup;
                } else {
                  that.setStatus(this.infoForm.ID);
                  that.getlx();
                  that.isPopup = !that.isPopup;
                }

                // if (this.lx == 1) {
                //   //that.submit(4);
                // }

                // this.Popups(0);
              } else {
                that.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => {
          that.batchArr = [];
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    Popups(e = 0, f) {
      if (e == 1) {
        this.infoForm = f;
      }
      this.addExpertReport = "";
      this.isPopup = !this.isPopup;
    },
    setStatus(ID) {
      let that = this;
      that.$axios
        .post(
          "report/updatestatus",
          that.$qs.stringify({
            token: sessionStorage.getItem("token"),
            ID: ID,
            Status: "4",
          })
        )
        .then((res) => {
          if (res.data.code != 10000) {
            that.$message.error(res.data.msg);
          } else {
            that.getlx();
          }
        });
    },
    Zhuanjias(e = 0, f) {
      this.isZhuanjia = e;
      var that = this;
      if (f) {
        that.dialogVisible1 = true;
        that.$axios
          .post(
            "review/index?token=" + sessionStorage.getItem("token"),
            that.$qs.stringify({
              ReportID: f.ID,
            })
          )
          .then((res) => {
            if (res.data.code == 10000) {
              this.tableData2 = res.data.data.list;
            } else {
              this.$message({
                message: res.data.msg,
                type: "warning",
              });
            }
          });
      }
    },
    getdoctor() {
      var that = this;
      that.$axios
        .post(
          "review/Selectdoctor?token=" + sessionStorage.getItem("token"),
          that.$qs.stringify({})
        )
        .then((res) => {
          // options里放所有专家组;
          // value1放已选的专家组ID[1,2];
          // 需要编写一个接口查找所有专家放到options里;
          // 这里假设这个接口是所有专家,这个成果需要每个专家来筛选;
          this.value1 = [];
          this.options = res.data.data;
          //this.options.forEach((el)=>{
          //  this.value1.push(el.Expertname);
          //})
        });
    },
    getteacher(reportid) {
      var that = this;
      that.$axios
        .post(
          "review/Selectoldview?token=" + sessionStorage.getItem("token"),
          that.$qs.stringify({
            ReportID: reportid,
          })
        )
        .then((res) => {
          // options里放所有专家组;
          // value1放已选的专家组ID[1,2];
          // 需要编写一个接口查找所有专家放到options里;
          // 这里假设这个接口是所有专家,这个成果需要每个专家来筛选;
          this.value1 = [];
          this.options = res.data.data;
          this.oldForm = res.data.data;
          this.options.forEach((el) => {
            this.value1.push(el.Expertname);
          });
        });
    },
    stateFormat(row) {
      if (row.fpzt === "0") {
        return "未分配";
      } else {
        return "已分配";
      }
    },
    search() {
      this.Page1 = 1;
      this.getlx();
    },
    getlx() {
      this.pageValue = this.lx;
      var that = this;
      switch (this.lx) {
        case "0":
          this.reportstatus = 1;
          break;
        case "1":
          this.reportstatus = 2;
          break;
        case "2":
          this.reportstatus = 4;
          break;
        case "3":
          this.reportstatus = 5;
          break;
        case "4":
          this.reportstatus = 7;
          break;
        case "5":
          this.reportstatus = "";
          break;
        default:
          1;
      }
      if (this.reportstatus == 2) {
        that.$axios
          .post("expertgroup/index?token=" + sessionStorage.getItem("token"))
          .then((res) => {
            if (res.data.code == 10000) {
              this.Groups = res.data.data.list;
            } else {
              this.$message({
                type: "warning",
                message: res.data.msg,
              });
            }
          });
      }
      that.$axios
        .post(
          "report/index?token=" + sessionStorage.getItem("token"),
          that.$qs.stringify({
            Status: this.reportstatus,
            page: this.Page1,
            num: this.PageSize1,
            ClassifyID: this.major2Value,
            keyword: this.keyword,
            year: this.year,
            SuperiorD: this.SuperiorD,
          })
        )
        .then((res) => {
          if (res.data.code == 10000) {
            var list = res.data.data.list;
            list.forEach((val) => {
              val.zyzb == 0
                ? (val.zyzb = "未填写")
                : val.zyzb == 1
                ? (val.zyzb = "已上报")
                : val.zyzb == 2
                ? (val.zyzb = "已退回")
                : (val.zyzb = "无");
              val.tyzb == 0
                ? (val.tyzb = "未填写")
                : val.tyzb == 1
                ? (val.tyzb = "已上报")
                : val.tyzb == 2
                ? (val.tyzb = "已退回")
                : (val.tyzb = "无");
            });
            var st = (this.Page1 - 1) * this.PageSize1;
            list.forEach((val, index) => {
              val.index = index + 1;
            });
            this.tableData1 = list.slice(
              this.Page1 == 1 ? 0 : st,
              this.PageSize1 * this.Page1
            );
            this.tableData1.forEach((val) => {
              val.DeclarTime = val.DeclarTime.split(" ")[0];
              this.S = !val.node_msg ? val.Status : "";
            });
            this.total1 = res.data.data.list.length;
          } else {
            this.$message({
              message: res.data.msg,
              type: "warning",
            });
          }
        });
    },

    setInfo() {
      var that = this;
      if (this.infoForm.fpzt === "0") {
        //插入review表

        that.$axios
          .post(
            "review/add?token=" + sessionStorage.getItem("token"),
            that.$qs.stringify({
              ReportID: this.infoForm.ID,
              group: 0,
            })
          )
          .then((res) => {
            if (res.data.code == 10000) {
              that.$message({
                message: res.data.msg,
                type: "success",
              });
              that.getinfo();
              this.Popups(0);
            } else {
              this.$message({
                message: res.data.msg,
                type: "warning",
              });
            }
          });
      } else {
        that.$axios
          .post(
            "review/update?token=" + sessionStorage.getItem("token"),
            that.$qs.stringify(this.oldForm)
          )
          .then((res) => {
            if (res.data.code == 10000) {
              that.$message({
                message: res.data.msg,
                type: "success",
              });
              that.getinfo();
              this.Popups(0);
            } else {
              this.$message({
                message: res.data.msg,
                type: "warning",
              });
            }
          });
      }
    },
    getReportcontent() {
      var that = this;
      that.$axios
        .post(
          "word/sbb?token=" + sessionStorage.getItem("token"),
          that.$qs.stringify({
            ReportID: this.user.ID,
          })
        )
        .then((res) => {
          if (res.data.code == 10000) {
            this.sbb = res.data.data;
          }
        });
      that.$axios
        .post(
          "word/words",
          that.$qs.stringify({
            token: sessionStorage.getItem("token"),
            ReportID: that.user.ID,
          })
        )
        .then((res) => {
          this.zgzbg1 = res.data.data;
        });
      that.$axios
        .post(
          "reportcontent/info?token=" + sessionStorage.getItem("token"),
          that.$qs.stringify({
            ReportID: this.user.ID,
            MouldID: this.user.MouldID,
          })
        )
        .then((res) => {
          if (res.data.code == 10000) {
            this.contentInfo = res.data.data;
            this.yulan = JSON.stringify(this.contentInfo);
            this.sbbYear = res.data.year;
            this.contentInfo.forEach((el) => {
              if (el.Title == "cgzbg") {
                //按顺序写入数组
                this.cgzbg = el.Content;
              }
              if (el.Title == "fj1") {
                //按顺序写入数组
                this.fj = el.Content;
              }
              // if (el.Title == "sbb") {
              //   console.log(el.Content);
              //   this.sbb = el.Content;
              // }
            });
            /*console.log(el,"报告1111")
              if (el.Title == "cgzbg_cggy") {
                //按顺序写入数组
                this.zbgdata[0] = el.Content;
              }
              if (el.Title == "cgzbg_qyjj") {
                this.zbgdata[1] = el.Content;
              }
              if (el.Title == "cgzbg_ssbj") {
                this.zbgdata[2] = el.Content;
              }
              if (el.Title == "cgzbg_nh") {
                this.zbgdata[3] = el.Content;
              }
              if (el.Title == "cgzbg_zyzf") {
                this.zbgdata[4] = el.Content;
              }
              if (el.Title == "cgzbg_ssxg") {
                this.zbgdata[5] = el.Content;
              }
            });
            this.showall = "";

            for (var i = 0; i < this.zbgdata.length; i++) {
              this.showall += "" + this.zbgdata[i];
            }*/
          } else {
            this.$message({
              message: res.data.msg,
              type: "warning",
            });
          }
        });
    },
    bgreviewView(row) {
      this.user = row;
      this.$axios
        .post(
          "flow/flowtimeline",
          this.$qs.stringify({
            ReportID: this.user.ID,
            token: sessionStorage.getItem("token"),
          })
        )
        .then((res) => {
          if (res.data.code == 10000) {
            // var val = res.data.data[res.data.data.length - 1];
            // console.log(val);
            // if (
            //   val.sysmsg == "审核通过！" &&
            //   val.companyName == "中国煤炭工业协会"
            // ) {
            //   this.c = val.comment;
            //   console.log(this.c, 4);
            // }
            res.data.data.forEach((val) => {
              if (
                val.operation == "2" &&
                val.companyName == "中国煤炭工业协会"
              ) {
                this.ideas = val.comment;
              }
            });
          } else if (res.data.code == 10002) {
            this.$message({
              type: "warning",
              message: res.data.msg,
            });
          } else {
            this.$message.error(res.data.msg);
          }
        });
      this.getReportcontent(); //获取文件地址
      this.getBaogao();
      this.bgreviewVisible = true;
    },
    close() {
      this.bgreviewVisible = false;
      this.getlx();
    },
    childchange(row) {
      this.user = row;
      this.childVisible = true;
    },

    tabchange(a, b, c) {
      if (c != 3) {
        this.tabClick = a;
      }

      if (this.lx == 0) {
        if (b) {
          this.user = b;
          // this.getBaogao()
          if (a == 3) {
            this.$nextTick(() => {
              this.childVisible = true;
              this.tabClick = 0;
              // this.$refs.child.showTable = false;
            });
          } else {
            this.getReportcontent(); //获取文件地址
            this.getBaogao();
          }

          //this.getReview();
        }
      } else {
        this.Popups(1);
      }
      if (a == 1 && b) {
        this.user = b;
        this.$axios
          .post(
            "flow/flowtimeline",
            this.$qs.stringify({
              ReportID: this.user.ID,
              token: sessionStorage.getItem("token"),
            })
          )
          .then((res) => {
            if (res.data.code == 10000) {
              // var val = res.data.data[res.data.data.length - 1];
              // console.log(val);
              // if (
              //   val.sysmsg == "审核通过！" &&
              //   val.companyName == "中国煤炭工业协会"
              // ) {
              //   this.c = val.comment;
              //   console.log(this.c, 4);
              // }
              res.data.data.forEach((val) => {
                if (
                  val.operation == "2" &&
                  val.companyName == "中国煤炭工业协会"
                ) {
                  this.ideas = val.comment;
                }
              });
            } else if (res.data.code == 10002) {
              this.$message({
                type: "warning",
                message: res.data.msg,
              });
            } else {
              this.$message.error(res.data.msg);
            }
          });
        this.getReportcontent(); //获取文件地址
        this.getBaogao();
      }
      if (c) {
        this.lookStatus = c;
      }

      if (c == 3) {
        if (this.fj) {
          window.location.href = this.fj;
        } else {
          this.$message({
            message: "暂无附件信息",
            type: "warning",
          });
        }
      }
    },

    CurrentChange1(val) {
      this.Page1 = val;
      this.getlx();
      //this.GetClass()
    },
    handleSizeChange1(val) {
      // console.log(val)
      this.PageSize1 = val;
      this.getlx();
      //this.GetClass()
    },
  },
  watch: {
    keyword: function() {
      this.Page1 = 1;
      this.getlx();
    },
  },
  components: {
    Head,
    Foot,
    Nav,
    Preview,
    FullPreview,
    SpecificationDialog,
    BgreviewDialog,
  },
};
</script>
<style lang="less">
#Bgreviewtwo {
  .Specification {
    .H-right {
      float: none;
    }
  }

  .t-left {
    .el-input__inner {
      font-size: 0.16rem;
      width: 2rem;
      height: 0.4rem;
      line-height: 0.4rem;
    }
  }

  .el-dialog__header {
    text-align: center;
  }

  .el-card:hover {
    border: 1px solid lightblue;
  }

  .el-dialog {
    .el-dialog__title {
      font-size: 0.2rem;
      font-weight: 400;
    }

    .el-step__head.is-process {
      color: #c0c4cc;
      border-color: #c0c4cc;
    }

    .el-step__title.is-finish {
      color: #303133;
    }

    .el-step__title.is-process {
      font-weight: normal;
    }

    .el-step__description.is-finish {
      color: #303133;

      .content {
        display: flex;
        margin-bottom: 0.2rem;

        .opinion {
          text-indent: 2em;
        }
      }

      p {
        width: 1.6rem;
        height: 0.5rem;
      }

      // div {
      //   width: 1.2rem;
      //   height: 0.4rem;
      //   line-height: 0.4rem;
      //   text-align: center;
      //   color: #fff;
      //   background: #2d65d2;
      //   margin: 0 auto;
      //   margin-top: 0.1rem;
      //   cursor: pointer;
      // }
    }

    .watch {
      margin-top: 0.3rem;
      border-top: 1px solid #aaa;
      padding-top: 0.16rem;
      color: #333;

      p {
        font-size: 0.18rem;
        margin-bottom: 0.16rem;
        font-weight: bold;
      }

      div {
        text-indent: 2em;
        line-height: 2;
      }
    }
  }
}
</style>
<style lang="less" scoped>
.btns {
  display: flex;
  justify-content: center;
}

.time {
  position: relative;

  .time-select {
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
  }
}

.clear:after {
  /*伪元素是行内元素 正常浏览器清除浮动方法*/
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}

.btn {
  width: 3rem;
  cursor: pointer;
  height: 0.58rem;
  line-height: 0.58rem;
  font-size: 0.17rem;
  text-align: center;
  background: #2d65d2;
  color: #fff;
}

.btnchange {
  background-color: #f2f2f4;
  color: #000000;
}

.btnmini {
  width: 1rem;
  height: 0.4rem;
  line-height: 0.4rem;
  border-radius: 0.05rem;
}

.hotspot {
  width: 100%;
  min-width: 1000px;
  font-size: 0.16rem;
  padding: 0.28rem 1rem 0 2.54rem;
  box-sizing: border-box;

  .H-right {
    position: relative;
    width: 13rem;
    min-width: 750px;
    padding-left: 0.2rem;
    height: 100%;
    float: right;
    min-height: 7.4rem;
    border-left: 1px #eeeeee solid;

    // .left-button {
    //   display: flex;
    //   .lastBtn {
    //     margin-left: 0.6rem;
    //   }
    // }
    .title1 {
      font-size: 0.4rem;
      margin: 0.2rem 0 0.5rem;
      text-align: center;
    }

    .btnselect {
      display: flex;
    }

    .H-header {
      .t-left {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 0.5rem;
        position: relative;

        .select {
          display: flex;
          width: 80%;
        }

        .btn1 {
          background: rgb(247, 100, 35);
          width: 1.5rem;
          height: 0.4rem;
          color: #fff;
          border-radius: 0.05rem;
          text-align: center;
          line-height: 0.4rem;
          display: flex;
          position: absolute;
          right: 1rem;
          cursor: pointer;
          top: 0.05rem;
          z-index: 10;
          justify-content: space-around;
          align-items: center;
          padding: 0 0.15rem;

          i {
            // margin: 0.07rem 0.2rem 0 0.2rem;
            width: 0.28rem;
            height: 0.28rem;
            background-image: url("../../assets/back/Excel.png");
            background-repeat: no-repeat;
            background-size: 100% 100%;
            // background-size: 50%  100%;
          }
        }

        > span,
        select,
        div,
        input {
          margin-right: 0.2rem;
          width: 2rem;
          height: 0.4rem;
        }

        input {
          padding: 0.05rem;
        }
      }

      .t-right {
        float: right;
      }
    }

    .t_main {
      .table {
        .list {
          width: 100%;
          display: flex;
          padding-bottom: 0.2rem;
          align-items: center;
          position: relative;
          border-bottom: 1px #d9d9d9 solid;

          &:hover {
            background: #f0f0f0;
          }

          .btn {
            position: absolute;
            top: 0.2rem;
            right: 0.2rem;
          }

          .l-right {
            width: 3.14rem;
            height: 1.56rem;
            position: relative;

            img {
              width: 100%;
              height: 100%;
            }
          }

          .l-info {
            flex: 1;
            // padding-left: 0.3rem;
            font-size: 0.16rem;
            color: #4e4e4e;
            height: 100%;

            .l-info-name {
              span {
                font-size: 0.2rem;
                font-weight: bold;
                color: #171717;
                line-height: 0.5rem;
              }

              i {
                font-style: normal;
                background: #ff0a0a;
                color: #ffffff;
                display: inline-block;
                font-size: 0.14rem;
                margin-left: 0.2rem;
                height: 0.19rem;
                text-align: center;
                border-radius: 0.04rem;
              }
            }

            .l-info-text {
              height: 0.5rem;
              margin-bottom: 0.1rem;
            }

            .l-info-time {
              margin-right: 0.2rem;
              margin-bottom: 0.1rem;
            }

            .l-info-text {
              span {
                float: left;
                font-weight: 800;
                margin-right: 0.2rem;
                line-height: 0.25rem;
              }

              div {
                margin-left: 0.4rem;
                line-height: 0.25rem;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 3;
                overflow: hidden;
              }
            }
          }
        }
      }
    }

    // .l-main{
    //   .list{
    //     display: flex;
    //     // justify-content: space-around;
    //     align-items: center;
    //     border-bottom: 1px #d9d9d9 solid;
    //     padding: 0.2rem 0;
    //     .content{
    //       flex: 1;
    //       .content-name{
    //         margin-bottom: 0.15rem;
    //         span{
    //           font-size: .2rem;
    //           font-weight: bold;
    //           // line-height: 2.5;
    //         }
    //       }
    //       .content-group{
    //         margin: 0.1rem 0;
    //       }
    //     }
    //     .btn{
    //       align-self: start;
    //       // margin-top: 0.2rem;
    //     }
    //   }
    // }

    .title {
      margin: 0.5rem 0;
      font-size: 0.18rem;
      font-family: Microsoft YaHei;

      > input {
        float: right;
        height: 0.35rem;
        margin-right: 50%;
        padding: 0.05rem;
      }

      > div {
        display: flex;
        height: 0.35rem;
        align-items: center;

        > div {
          height: 0.05rem;
          width: 0.05rem;
          border-radius: 50%;
          background: #2d65d2;
          margin-right: 0.2rem;
        }
      }
    }

    .jieguo {
      font-size: 0.18rem;
      font-weight: bold;
      margin: 0.5rem 0;
      display: flex;
      align-items: center;

      .repetition {
        width: 1.1rem;
        height: 0.4rem;
        background: #ff0000;
        border-radius: 0.05rem;
        color: #fff;
        text-align: center;
        line-height: 0.4rem;
      }

      .jieguospan {
        color: #1c1c1c;
        margin-left: 0.05rem;
      }

      // line-height: 100%;
      // height: .4rem;
      i {
        display: inline-block;
        width: 0.35rem;
        height: 0.35rem;
        background-image: url("../../assets/back/serach.png");
        background-size: 80%;
        background-repeat: no-repeat;
        background-position: 100% 100%;
        margin-right: 0.05rem;
      }

      span {
        color: #d93838;
        margin-right: 0.2rem;
      }

      a {
        font-weight: 400;
        text-decoration: underline;
        cursor: pointer;
      }
    }

    .yijian {
      div:first-of-type {
        display: flex;
        height: 0.35rem;
        align-items: center;

        > div {
          height: 0.05rem;
          width: 0.05rem;
          border-radius: 50%;
          background: #2d65d2;
          margin-right: 0.2rem;
        }
      }

      textarea {
        position: relative;
        top: -0.35rem;
        left: 1.1rem;
        width: 80%;
      }

      .opinion {
        // width: 60%;
        border: 1px solid #ccc;
        padding: 0.1rem;
        margin: 0.15rem 0;
      }
    }

    .sub {
      width: 100%;
      display: flex;
      justify-content: center;

      div {
        border-radius: 0.1rem;
      }
    }
  }
}

.block {
  .el-card__body {
    .head {
      display: flex;
      align-items: center;
      margin-bottom: 0.2rem;

      img {
        width: 0.4rem;
      }

      h4 {
        margin: 0 0.1rem;
      }

      div {
        margin-left: 0.2rem;
        font-size: 0.14rem;

        span {
          margin-right: 0.2rem;
        }
      }
    }

    .content {
      width: 100%;
      margin-bottom: 0.2rem;

      div {
        width: 100%;
        margin-bottom: 0.2rem;
      }

      div:last-of-type {
        margin-bottom: 0;
      }

      .score {
        span {
          margin-right: 0.3rem;
        }
      }

      .yj {
        display: flex;

        span {
          width: 8%;
        }

        div {
          width: 90%;
          // text-indent: 2em;
        }
      }

      .contentMsg {
        position: relative;
        padding-left: 10px;
      }

      .contentMsg ::before {
        content: "";
        background-color: #3796ec;
        width: 3px;
        height: 0.45rem;
        position: absolute;
        left: 0;
        top: 10%;
        // margin-top: -9px;
        -webkit-border-radius: 3px;
        -moz-border-radius: 3px;
        border-radius: 3px;
      }
    }
  }
}

.Popup {
  width: 100%;
  position: absolute;
  top: 0;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 1000;

  .none {
    width: 100%;
    height: 100%;
    position: relative;
  }

  .a_forms {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 7rem;
    //height: 6rem;
    background: white;
    font-size: 0.16rem;

    .f-top {
      height: 0.3rem;
      width: 100%;
      text-align: center;
      line-height: 0.5rem;
      position: relative;

      // border-bottom: 1px #cfcfcf solid;
      .el-icon-close {
        width: 0.5rem;
        height: 0.5rem;
        position: absolute;
        right: 0.1rem;
        top: 0.1rem;
        cursor: pointer;
      }

      div {
        cursor: pointer;
        position: absolute;
        right: 0;
        top: 0;
        height: 0.5rem;
        width: 0.5rem;
        background: url("../../assets/back/x.png") center center no-repeat;
      }
    }

    .f-info {
      padding: 0.2rem 0.68rem 0;

      .p-info {
        > .p-input {
          align-items: center;
        }

        > .upimg {
          align-items: center;
          justify-content: space-between;
        }

        > div {
          margin: 0.2rem 0;
          display: flex;

          > .p-time {
            position: relative;
            flex: 1;
            margin: 0 0.2rem;

            > input {
              width: 100%;
              padding: 0.05rem;
              height: 0.3rem;
              border: 1px #cccccc solid;
            }

            .p-select {
              width: 100%;
              top: 0;
              left: 0;
              opacity: 0;
              position: absolute;
            }

            .icon {
              position: absolute;
              top: 0;
              right: 0;
              height: 0.3rem;
              width: 0.3rem;
              background: url("../../assets/back/time.png") center center
                no-repeat;
            }
          }

          > input,
          select {
            flex: 1;
            padding: 0.05rem;
            margin: 0 0.2rem;
            height: 0.4rem;
            border: 1px #cccccc solid;
          }

          > textarea {
            flex: 1;
            padding: 0.05rem;
            margin: 0 0.2rem;
            border: 1px #cccccc solid;
          }

          i {
            font-style: normal;
            color: #ff0d0d;
          }
        }
      }

      .f-bottom {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding: 0.5rem 0;
      }
    }
  }
}

.el-dropdown {
  display: none;
}

.btns {
  display: flex;
}

@media screen and (max-width: 1800px) {
  .el-dropdown {
    display: block;
  }

  .btns {
    display: none !important;
  }

  .el-table__row td:last-child {
    .cell {
      padding-left: 0px;

      .el-button {
        font-size: 12px;
      }
    }
  }

  .el-dropdown-menu {
    li {
      padding: 0;

      span {
        display: inline-block;
        padding: 0 20px;
        width: 100%;
        height: 100%;
      }
    }

    li:hover {
      color: #fff !important;
      background: #2d65d2;
    }

    li:first-of-type:hover {
      background: #2d65d2;
    }

    li:nth-of-type(2):hover {
      background: #f3252f;
    }

    li:nth-of-type(3):hover {
      background: #f5be1a;
    }

    li:last-of-type:hover {
      background: #f76423;
    }
  }
}

.search-input {
  width: 3rem !important;

  /deep/ .el-input {
    width: 3rem !important;

    .el-input__inner {
      width: 3rem !important;
    }
  }

  /deep/ .el-input__inner {
    width: 3rem !important;
  }
}
</style>
